import Component from '../core/Component'

export default class More extends Component {
    constructor(element) {
        super(element);
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(e) {
        e.preventDefault();

        if (this.element.getAttribute("data-text-swap") == this.element.innerHTML) {
          this.element.innerHTML = this.element.getAttribute("data-text-original");
          this.element.classList.add("is-active")
          this.element.previousElementSibling.classList.remove('is-unfolded');
        } else {
          this.element.setAttribute("data-text-original", this.element.innerHTML);
          this.element.innerHTML = this.element.getAttribute("data-text-swap");
          this.element.previousElementSibling.classList.add('is-unfolded');
        }
    }
}


// WEBPACK FOOTER //
// ./components/More.js